/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { MortalityAnalysisResponse } from '../../models/mortality-analysis-response';

export interface GetMortalityAnalysisData$Params {
  harvestId: number;
  groupIdx?: Array<number>;
}

export function getMortalityAnalysisData(http: HttpClient, rootUrl: string, params: GetMortalityAnalysisData$Params, context?: HttpContext): Observable<StrictHttpResponse<MortalityAnalysisResponse>> {
  const rb = new RequestBuilder(rootUrl, getMortalityAnalysisData.PATH, 'get');
  if (params) {
    rb.path('harvestId', params.harvestId, {});
    rb.query('groupIdx', params.groupIdx, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<MortalityAnalysisResponse>;
    })
  );
}

getMortalityAnalysisData.PATH = '/api/harvests/{harvestId}/mortality-analysis-data';
